import { BaseModel } from "@blue-chip/core";
import Program from "./Program";
import Vendor from "./Vendor";

export default class Discount extends BaseModel {
  static get belongsTo() {
    return [Program, Vendor];
  }
}
